// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__by_-F","footer":"ModalError_footer__15RWz"};